import * as React from 'react';

function SvgHeartOutline(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={40} height={40} viewBox="0 0 25 20" {...props}>
      <path
        transform="translate(0,-952.36218)"
        d="M12,975.5l-0.6-0.4c-4.7-3.5-10.9-8.9-10.9-14.8c0-3.1,2.7-6.5,6.8-6.5c2,0,3.5,1.2,4.8,2.5c1.2-1.3,2.8-2.5,4.8-2.5
			c4,0,6.8,3.4,6.8,6.5c0,6-6.2,11.3-10.9,14.8L12,975.5z M7.3,955.7c-2.8,0-4.8,2.4-4.8,4.5c0,5.3,6.6,10.5,9.5,12.8
			c2.9-2.2,9.5-7.5,9.5-12.8c0-2.1-2-4.5-4.8-4.5c-1.6,0-3,1.4-4,2.6l-0.8,0.9l-0.8-0.9C10.2,957.1,8.9,955.7,7.3,955.7z"
      />
    </svg>
  );
}

export default SvgHeartOutline;
